import styled from 'styled-components'
import { ButtonReg } from 'atoms/Buttons'

export const GroupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex: 1;
  padding-right: .5rem;
`

export const GroupedButton = styled(ButtonReg)`
  display: flex;
  flex: 1;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: ${({ height }) => (height ? height : '34px')};
  border-top-left-radius: ${({ idx }) => (idx === 0 ? '6px' : '0')};
  border-bottom-left-radius: ${({ idx }) => (idx === 0 ? '6px' : '0')};
  border-top-right-radius: ${({ len, idx }) => (idx === len-1 ? '6px' : '0')};
  border-bottom-right-radius: ${({ len, idx }) => (idx === len-1 ? '6px' : '0')};
  border: 1.5px solid ${({theme}) => theme.mocaPurple};
  background-color: ${({ sel, val, theme }) => (val === sel ? theme.mocaPurple : theme.white)};
  color: ${({ sel, val, theme }) => (val === sel ? theme.white : theme.black)};

  &:hover:enabled {
    opacity: 0.9;
  }

  &:focus {
    outline: none;
  }
`
